export function addMissingFields(feat, schema) {
  schema.forEach((fd) => {
    if (!feat.hasOwnProperty(fd.name)) {
      feat[fd.name] = "";
    }
  });
  return feat;
}
